module.exports = __webpack_public_path__ + "img/list-tree.8f7da3bc.svg";